'use client';
import { useRouter } from 'next/navigation';
import { useCallback, useState, useEffect } from 'react';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';
import { VipOnlyModalContainer } from '@app/_containers/vip-only-modal-container';

export type VipOnlyStoryRedirectedContainerProps = {
  storyId: string;
};

export const VipOnlyStoryRedirectedContainer = ({
  storyId,
}: VipOnlyStoryRedirectedContainerProps) => {
  const router = useRouter();
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    router.back();
  }, [router]);
  const { session } = useTellerSession();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (session && !session.tellerUser?.isVipUser) {
      setIsOpen(true);
    }
  }, [session]);

  return (
    <VipOnlyModalContainer
      storyId={storyId}
      isOpen={isOpen}
      onClose={handleOnClose}
    />
  );
};
